export default function ResultsTimelineSection() {
  const timeline = [
    {
      week: 'Semaine 1',
      title: 'Prise de conscience corporelle',
      description: 'Vous apprenez à identifier vos zones de tension et à reconnaître les premiers signaux de douleur avant qu\'elle ne s\'installe.',
      results: [
        'Meilleure écoute de votre corps',
        'Identification des déclencheurs',
        'Premières techniques de respiration'
      ],
      icon: 'ri-eye-line',
      color: 'from-[#E8956F] to-[#D67D5A]'
    },
    {
      week: 'Semaine 2',
      title: 'Gestion active de la douleur',
      description: 'Vous maîtrisez les protocoles sophrologiques spécifiques pour réduire la douleur pendant et après la monte.',
      results: [
        'Réduction de 40-60% de la douleur',
        'Techniques de relâchement musculaire',
        'Amélioration de la mobilité du bassin'
      ],
      icon: 'ri-heart-pulse-line',
      color: 'from-[#3D2817] to-[#2C1810]'
    },
    {
      week: 'Semaine 3',
      title: 'Retrouver le plaisir à cheval',
      description: 'Vous reconstruisez une relation sereine avec votre cheval, sans appréhension ni limitation liée à la douleur.',
      results: [
        'Confiance retrouvée en selle',
        'Séances plus longues et confortables',
        'Meilleure connexion avec votre cheval'
      ],
      icon: 'ri-emotion-happy-line',
      color: 'from-[#8B6F47] to-[#6B5537]'
    },
    {
      week: 'Semaine 4',
      title: 'Autonomie et pérennité',
      description: 'Vous êtes autonome dans la gestion de votre endométriose au quotidien et à cheval, avec des outils pour la vie.',
      results: [
        'Routine personnalisée maîtrisée',
        'Capacité d\'adaptation selon les cycles',
        'Outils pour accompagner d\'autres cavalières'
      ],
      icon: 'ri-trophy-line',
      color: 'from-[#A67C52] to-[#8B6F47]'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#FAF7F4]">
      <div className="max-w-7xl mx-auto px-6">
        {/* En-tête */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#E8956F]/10 px-4 py-2 rounded-full mb-6">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-chart-line text-[#E8956F] text-base"></i>
            </div>
            <span className="text-sm font-medium text-[#3D2817]">Résultats progressifs</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-[#3D2817] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Votre transformation en 4 semaines
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Un programme progressif et structuré pour des résultats durables. Découvrez ce qui vous attend semaine après semaine.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Ligne verticale */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#E8956F] via-[#3D2817] to-[#A67C52] transform -translate-x-1/2"></div>

          {/* Étapes */}
          <div className="space-y-12">
            {timeline.map((item, index) => (
              <div key={index} className={`flex flex-col md:flex-row gap-8 items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                {/* Contenu */}
                <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                  <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100">
                    <div className={`inline-block px-4 py-1.5 bg-gradient-to-r ${item.color} text-white rounded-full text-sm font-semibold mb-4`}>
                      {item.week}
                    </div>
                    <h3 className="text-2xl font-bold text-[#3D2817] mb-3" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      {item.title}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {item.description}
                    </p>
                    <div className="space-y-3">
                      {item.results.map((result, idx) => (
                        <div key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                            <i className="ri-checkbox-circle-fill text-[#E8956F] text-base"></i>
                          </div>
                          <span className="text-sm text-gray-700 flex-1">{result}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Icône centrale */}
                <div className="relative z-10">
                  <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${item.color} flex items-center justify-center shadow-lg`}>
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${item.icon} text-white text-2xl`}></i>
                    </div>
                  </div>
                </div>

                {/* Espace pour l'alignement */}
                <div className="flex-1 hidden md:block"></div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a 
            href="#formation"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#3D2817] text-white rounded-full text-base font-semibold hover:bg-[#2C1810] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span>Commencer ma transformation</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
